import { Stack } from "@mui/material";
import { Title } from "@src/appV2/redesign/system/ui-components";

interface BackgroundCheckInfoSectionProps {
  title: string;
  children: React.ReactNode;
}

export function BackgroundCheckInfoSection({ title, children }: BackgroundCheckInfoSectionProps) {
  return (
    <Stack spacing={2}>
      <Title semibold variant="h5" component="h2">
        {title}
      </Title>
      {children}
    </Stack>
  );
}
